module.exports = __webpack_public_path__ + "static/media/wil_logo-dots.8380b8cb.svg";